<template>
  <router-link to="/">
    <img style="padding-right: 20px;"
      class="img-fluid for-light"
      src="../../assets/images/logo/logo.png"
      alt=""
    /><img style="padding-right: 20px;"
      class="img-fluid for-dark"
      src="../../assets/images/logo/logo_dark.png"
      alt=""
    />
  </router-link>
</template>
<script>

  export default {
    name: 'Logo',
  };
</script>
